import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { BranchIntParams } from '../models/branch-international.model';
import { BranchInternationalResponse } from '../models/branch-international-response.model';
import { BranchesInternationalRepository } from '../repositories/branches-international.repository';

export class FindBranchesInternationalUseCase
    implements UseCase<BranchIntParams, BranchInternationalResponse>
{
    constructor(private readonly repository: BranchesInternationalRepository) {}

    execute(
        searchTerm: BranchIntParams,
    ): Observable<BranchInternationalResponse> {
        return this.repository.findBranchesInternational(searchTerm);
    }
}
